import { render, staticRenderFns } from "./writelist.vue?vue&type=template&id=2f2b78d7&scoped=true&"
import script from "./writelist.vue?vue&type=script&lang=js&"
export * from "./writelist.vue?vue&type=script&lang=js&"
import style0 from "./writelist.vue?vue&type=style&index=0&id=2f2b78d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b78d7",
  null
  
)

export default component.exports